import axios, { type AxiosError } from "axios";
import { API_CONFIG } from "./config";
import type { TApiError } from "./types";

const axiosRequestConfig = {
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout ?? 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  retry: 10,
};

export const axiosApi = axios.create(axiosRequestConfig);

axiosApi.interceptors.request.use((request) => {
  return request;
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(handleError(error));

    // if (error.response?.status === 401) {
    //     return Promise.reject(handleError(error));
    // }
  },
);

// Handle API errors
function handleError(error: AxiosError): TApiError {
  let messageReturn: {
    Code: number;
    HttpCode: number;
    ErrorCode: number;
    StatusCode: number;
    Message: string;
    StackTrace?: string | null;
  };

  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const errorData = error?.response?.data as any;

  if (errorData) {
    // Make sure to handle potential undefined values
    messageReturn = {
      Message: errorData?.message || errorData?.Error?.Message || "An error occurred",
      Code: errorData?.code || errorData?.Error?.Code,
      ErrorCode: -1,
      HttpCode: 400,
      StatusCode: 400,
      StackTrace: null,
    };
  } else if (error.request) {
    messageReturn = {
      Message: "No response received from server",
      Code: -1,
      ErrorCode: -1,
      HttpCode: 400,
      StatusCode: 400,
      StackTrace: null,
    };
  } else {
    messageReturn = {
      Message: error.message || "Request setup failed",
      Code: 0,
      ErrorCode: 0,
      HttpCode: Number(error?.code || 400),
      StatusCode: Number(error?.code || 400),
      StackTrace: null,
    };
  }

  return messageReturn;
}
